import React, { FC, useEffect, useState } from 'react';

import { Button, Container } from '@lglp/components';
import { useTranslation } from 'react-i18next';

import { COMMON } from 'translations';

import DropDownArrowIcon, {
  BounceDirection,
} from '../../Icons/DropDownArrowIcon';
import { ShareSocialMedia } from '../../ShareSocialMedia';
import styles from './ScrollUp.module.scss';

export const ScrollUp: FC = () => {
  const [isFixed, setFixed] = useState(false);

  const { t } = useTranslation();

  const scrollToTop = (): void => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const handleScroll = (): void => {
    if (typeof window !== 'undefined') {
      const doc = document.documentElement;
      const topPosY =
        (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      const shouldFixPageUp =
        topPosY > 0 ? doc.scrollHeight / topPosY < 20 : false;
      if (!isFixed && shouldFixPageUp) {
        setFixed(true);
      } else if (isFixed && !shouldFixPageUp) {
        setFixed(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return (): void => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <Container
      className={[styles.goTopButtonWrapper, isFixed ? styles.fixed : '']}
    >
      <Button
        onClick={scrollToTop}
        id="go-top-button"
        className={styles.goTopButton}
      >
        <DropDownArrowIcon
          bounceDirection={BounceDirection.TOP}
          className={styles.goTopArrow}
        />
        <Button.Label>{t(COMMON.PAGE_TOP)}</Button.Label>
      </Button>
      <ShareSocialMedia />
    </Container>
  );
};
